import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, ViewEncapsulation, ElementRef, Inject, AfterContentInit, OnInit, OnDestroy, ViewChild, AfterViewInit } from '@angular/core';
import { UtilitiesService } from '@toro/common/shared/services/utilities.service';
import { DialogComponentContent } from '@toro/common/shared/models/dialogs/DialogComponentContent';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { Store } from '@ngrx/store';
import { AppState } from '@toro/common/shared/interfaces/app-state.interface';
import { AgreementsAction } from '@toro/common/shared/state-management/agreements/agreements.action';
import { Observable } from 'rxjs/Observable';
import { AgreementsState } from '@toro/common/shared/state-management/agreements/agreements.reducer';
import { AgreementsEffects } from '@toro/common/shared/state-management/agreements/agreements.effects';
import { ApplicationMessagesAction } from '@toro/common/shared/state-management/application-messages/application-message.action';
import { UserProfileActions } from '@toro/common/shared/state-management/userprofile/userprofile.actions';
import { RiskModel } from '@toro/common/shared/enum/risk-model.enum';
import { UserProfileEffects } from '@toro/common/shared/state-management/userprofile/userprofile.effects';
import { UserProfileState } from '@toro/common/shared/state-management/userprofile/userprofile.reducer';
import { Subscription } from 'rxjs/Subscription';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { AuthorizationWraperService } from '@toro/common/shared/services/authorization-wraper/authorization.wraper.service';
import { AuthorizationScenario } from '@toro/common/shared/enum/authorization-scenario.enum';
import { AuthorizationResultPayload } from '@toro/common/shared/models/authorization/authorization-result-payload.model';
import { HubAuthorizationComponent } from '@toro/common/shared/components/hub-authorization/hub-authorization.component';
import { TooltipDirective } from '@toro/common/shared/directives/tooltip/tooltip.directive';

const leveragedRiskAgreementFile = '7eb4e5b3-c51e-45be-ab5d-ed0ffc14d669';

@AutoUnsubscribe()
@Component({
    templateUrl: './confirm-enable-warranty.component.html',
    styleUrls: ['./confirm-enable-warranty.component.scss'],
    encapsulation: ViewEncapsulation.None,
})
export class ConfirmEnableWarrantyComponent extends DialogComponentContent implements AfterViewInit, OnInit, OnDestroy {

    public termsForm: FormGroup;
    public leveragedRiskAgreement: any;
    public agreements$: Observable<AgreementsState>;
    public userProfile$: Observable<UserProfileState>;
    public message: string = '';
    public agreementFile: string = 'https://cdn.toroinvestimentos.com.br/corretora/documents/termo-de-adesao-ao-modelo-de-risco-alavancado.pdf';
    @ViewChild('messageElement', {static: true}) public messageElement: ElementRef;

    private acceptAgreementSuccessSubscription: Subscription;
    private getAgreementErrorSubscription: Subscription;
    private updateRiskModelSubscription: Subscription;
    private acceptAgreementErrorSubscription: Subscription;
    private agreementsSubscription: Subscription;
    private tokenSubscription: Subscription;

    private acceptedAgreements: any;
    private agreementsToAccept: any[] = [];

    private tooltipTemplate: string = `<div>         
            <div class='pop-title'>Futuros</div>
            <div class='pop-content'>
                Futuros ou Contratos Futuros é a negociação do preço futuro de um ativo. Ele pode ser tanto um objeto 
                (Milho, Café, Boi Gordo), uma moeda (como o dólar), um Índice (Bovespa, Índice S&P 500) ou mesmo uma taxa de juros.
            </div>
        </div>`;

    private defaultMessage: string = `Ativando esta opção, você está concordando em usar suas ações e títulos de renda fixa para
        aumentar o valor disponível para investir. 
        Sempre que fizer investimentos em 
        <span class="popover-link">futuros</span> 
        ou investimentos em Bolsa planejados e com duração máxima de 1 dia, o valor não será mais debitado na conta corrente. 
        Ao invés disso, o valor aparecerá como investimento em Bolsa até que seja encerrado. O lucro/prejuízo dos investimentos 
        será debitado/creditado diretamente na sua conta corrente da corretora.`;

    constructor(
        @Inject(MAT_DIALOG_DATA) private data,
        public elementRef: ElementRef,
        private dialogReference: MatDialogRef<ConfirmEnableWarrantyComponent>,
        private utilititesService: UtilitiesService,
        private formBuilder: FormBuilder,
        private store: Store<AppState>,
        private agreementsEfffects: AgreementsEffects,
        private userProfileEffects: UserProfileEffects,
        private authorizationPanel: MatDialogRef<HubAuthorizationComponent>,
        private authorizationWraperService: AuthorizationWraperService
    ) {

        super(elementRef, '.modal-terms');

        this.message = (this.data && this.data.customMessage) ? this.data.customMessage : this.defaultMessage;

        this.termsForm = this.formBuilder.group({
            agree: ['', Validators.required],
        });
        this.agreements$ = this.store.select((state) => state.agreements);
        this.userProfile$ = this.store.select((state) => state.userProfile);

        this.agreementsSubscription = this.agreements$.filter((item) => item.agreements[leveragedRiskAgreementFile])
            .subscribe((agreements) => {
                this.leveragedRiskAgreement = agreements.agreements[leveragedRiskAgreementFile];
                this.acceptedAgreements = agreements.acceptedAgreements;

                // Verificação dos contratos já aceitos pelo usuário
                for ( const key in this.leveragedRiskAgreement ) {
                    if ( this.leveragedRiskAgreement.hasOwnProperty[key] ) {
                        this.agreementsToAccept.push(
                            this.acceptedAgreements.find((agreement) => agreement.contractGuid !== this.leveragedRiskAgreement[key]),
                        );
                    }
                }
            });

        this.store.dispatch({ type: AgreementsAction.getAgreementData, payload: leveragedRiskAgreementFile });
        this.store.dispatch({ type: AgreementsAction.getAccepted });
        this.store.dispatch({ type: UserProfileActions.getRiskModel });
    }

    public ngOnInit() {
        /** Contrato aceito */
        this.acceptAgreementSuccessSubscription = this.agreementsEfffects.acceptAgreement$
            .filter((item) => {
                return item.type.equals(AgreementsAction.acceptAgreementSuccess) && item.payload.agreementId === this.leveragedRiskAgreement.id;
            })
            .subscribe((action) => {
                this.store.dispatch({type: UserProfileActions.updateRiskModel, payload: RiskModel.Two});
            });

        /** Erro ao aceitar o contrato */
        this.acceptAgreementErrorSubscription = this.agreementsEfffects.acceptAgreement$
            .filter((item) => item.type.equals(AgreementsAction.acceptAgreementError))
            .subscribe((action) => {
                this.store.dispatch({ type: ApplicationMessagesAction.genericError, payload: action.payload });
            });

        /** Modelo alterado */
        this.updateRiskModelSubscription = this.userProfileEffects.updateRiskModel$
            .subscribe((action) => {
                // Fecha caixa de segundo fator de autenticação
                this.authorizationPanel.close();
                if (action.type.equals(UserProfileActions.updateRiskModelSuccess)) {
                    this.dispose(true);
                    return;
                }
                this.store.dispatch({ type: ApplicationMessagesAction.genericError, payload: action.payload });
            });

        /** Contrato não recuperado */
        this.getAgreementErrorSubscription = this.agreementsEfffects.getAgreementData$
            .filter((item) => item.type.equals(AgreementsAction.getAgreementDataError))
            .subscribe((item) => {
                this.store.dispatch({ type: ApplicationMessagesAction.genericError });
            });
    }

    public ngAfterViewInit() {
        this.startTooltip();
    }

    /**
     * Encerra o componente informando se há confirmação para realizar o
     * investimento
     * @param confirm confirmação para realizar ou não do investimento.
     */
    public dispose(confirm: boolean = false) {
        this.dialogReference.close(confirm);
    }

    public formSubmitHandler(event: Event) {
        event.preventDefault();

        this.authorizationPanel = this.authorizationWraperService.requestUserAuthorization(AuthorizationScenario.AuthenticateUserUsingSmsToken);

        this.tokenSubscription =  this.authorizationPanel.componentInstance.onTokenAvaliable
            .subscribe((token: AuthorizationResultPayload) => {
                    // Altera o modelo de risco do usuário
                this.store.dispatch({ type: UserProfileActions.updateRiskModel, payload: RiskModel.Two.toString(), ...token });

                // Aceita o contrato do modelo de risco parametrizado
                if ( this.agreementsToAccept ) {
                    this.agreementsToAccept.forEach((agreement) => {
                        if ( agreement && agreement.contractGuid ) {
                            this.store.dispatch({ type: AgreementsAction.acceptAgreement, payload: {
                                contractGuid: agreement.contractGuid,
                                versionId: agreement.versionID,
                                status: true,
                                agreementId: agreement.id,
                            }});
                        }
                    });
                }
            });
    }

    public startTooltip() {
        const element = this.messageElement.nativeElement.querySelector('.popover-link') as HTMLElement;
        if (element) {
            const tooltip = new TooltipDirective(new ElementRef(element));
            tooltip.tooltip = this.tooltipTemplate;
            tooltip.ngOnInit();
        }
    }

    // não remover, necessário para o funcionamento correto do @AutoUnsubscribe
    // tslint:disable-next-line: no-empty
    public ngOnDestroy() { }
}
